export default __webpack_public_path__ + "static/media/Sacae1.0b274fdb.png";